import React, { useEffect, useState } from "react";
import "./ChangePasswordForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import * as Yup from "yup";
import { activateURL, changePasswordURL } from "../../../../Hooks/URL";
import useActivate from "../../../../Hooks/useActivate";
import useSave from "../../../../Hooks/useSave";
import { useCookies } from "react-cookie";

const ActivateSchema = Yup.object().shape({
  oldPassword: Yup.string()
    // .min(8, "Password is too short !!")
    // .test(
    //   "isValidPass",
    //   "Password must contain at least 1 number, 1 uppercase, 1 lowercase, 1 special character !!",
    //   (value, context) => {
    //     const hasUpperCase = /[A-Z]/.test(value);
    //     const hasLowerCase = /[a-z]/.test(value);
    //     const hasNumber = /[0-9]/.test(value);
    //     const hasSymbol = /[!@#%&]/.test(value);
    //     let validConditions = 0;
    //     const numberOfMustBeValidConditions = 4;
    //     const conditions = [hasLowerCase, hasUpperCase, hasNumber, hasSymbol];
    //     conditions.forEach((condition) =>
    //       condition ? validConditions++ : null
    //     );
    //     if (validConditions >= numberOfMustBeValidConditions) {
    //       return true;
    //     }
    //     return false;
    //   }
    // )
    .required("Password required !!"),
  newPassword: Yup.string()
    .min(8, "Password is too short !!")
    .test(
      "isValidPass",
      "Password must contain at least 1 number, 1 uppercase, 1 lowercase, 1 special character !!",
      (value, context) => {
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumber = /[0-9]/.test(value);
        const hasSymbol = /[!@#%&]/.test(value);
        let validConditions = 0;
        const numberOfMustBeValidConditions = 4;
        const conditions = [hasLowerCase, hasUpperCase, hasNumber, hasSymbol];
        conditions.forEach((condition) =>
          condition ? validConditions++ : null
        );
        if (validConditions >= numberOfMustBeValidConditions) {
          return true;
        }
        return false;
      }
    )
    .required("New password required !!"),
  confirmNewPassword: Yup.string()
    .min(8, "Password is too short !!")
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Password required !!"),
});

function ChangePasswordForm({ handleClose }) {
  const [t, i18n] = useTranslation("common");
  const [cookies, setCookie] = useCookies(["TOKEN"]);
  const [newObject, setNewObject] = useState({});
  const [goSave, setGoSave] = useState(false);
  const [newUser, setNewUser] = useState(false);
  const { saveState, loading } = useSave({
    url: `${changePasswordURL}`,
    goSave,
    setGoSave,
    newObject,
  });

  useEffect(() => {
    if (saveState?.dataRes?.status == "success") {
      handleClose();
    }
  }, [saveState]);

  return (
    <div className="FormWrapper">
      <Formik
        initialValues={{
          oldPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        }}
        validationSchema={ActivateSchema}
        onSubmit={(values) => {
          setNewObject(values);
          setGoSave(true);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form
            className="LoginFormContainer"
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <TextFieldInput
              fullWidth
              name="oldPassword"
              type="password"
              placeholder={"Enter your current password"}
              className="LoginInput"
              label="Password"
              change={handleChange}
              blur={handleBlur}
              newValue={values.oldPassword}
            />
            {errors.oldPassword &&
              touched.oldPassword &&
              errors.oldPassword && (
                <p className="error">
                  {errors.oldPassword &&
                    touched.oldPassword &&
                    errors.oldPassword}
                </p>
              )}

            <TextFieldInput
              fullWidth
              name="newPassword"
              type="password"
              placeholder={"Enter a new password"}
              className="LoginInput"
              label="Confirm Password"
              change={handleChange}
              blur={handleBlur}
              newValue={values.newPassword}
            />
            {errors.newPassword &&
              touched.newPassword &&
              errors.newPassword && (
                <p className="error">
                  {errors.newPassword &&
                    touched.newPassword &&
                    errors.newPassword}
                </p>
              )}

            <TextFieldInput
              fullWidth
              name="confirmNewPassword"
              type="password"
              placeholder={"Enter your password again"}
              className="LoginInput"
              label="Confirm Password"
              change={handleChange}
              blur={handleBlur}
              newValue={values.confirmNewPassword}
            />
            {errors.confirmNewPassword &&
              touched.confirmNewPassword &&
              errors.confirmNewPassword && (
                <p className="error">
                  {errors.confirmNewPassword &&
                    touched.confirmNewPassword &&
                    errors.confirmNewPassword}
                </p>
              )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <PrimaryButton
                classBtn={"center addButton"}
                btnType={"submit"}
                text={"Submit"}
                loading={loading}
                style={{
                  textTransform: "capitalize",
                  marginTop: "15px",
                  width: "50%",
                  borderRadius: "5px",
                  color: "var(--text-secondary)",
                  backgroundColor: "var(--primary)",
                }}
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default ChangePasswordForm;
